import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

const NoAccess = () => {
    const { t } = useTranslation();

    return (
        <Box
            sx={{
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                fontSize: '1.5rem',
                fontWeight: 600,
            }}
        >
            🚫 {t('no_permission_message')}
        </Box>
    );
};

export default NoAccess;
